import $api from "../http";
import {
  IContractForTable,
  ICreateOrUpdateContract,
  IContractForAssign,
  IAssignContract,
} from "../models/Contract";

class ContractServiceClass {
  async createOrUpdateContract(model: ICreateOrUpdateContract) {
    return await $api.post<{}>("api/contract", model);
  }

  async getAll(currentPage: number | undefined, pageSize: number | undefined) {
    let queryString = `currentPage=${currentPage}&pageSize=${pageSize}`;
    return $api.get<{ data: IContractForTable[]; totalCount: number }>(
      `api/contract?${queryString}`
    );
  }

  async getAllForAssign() {
    return $api.get<IContractForAssign[]>(`api/contract/all-for-assign`);
  }

  async assign(model: IAssignContract) {
    return await $api.post<{}>("api/contract/assign", model);
  }
}

export const ContractService = new ContractServiceClass();
